import { Routes, Route } from "react-router-dom";
import React, { lazy, useState } from "react";

import { useEffect } from "react";
// import EmoneyTipPage from "features/emoneyTip";
// import SuccessPage from "features/success";
import DowntimePage from "features/downtime";
// import PrivacyPage from "features/privacy/PrivacyPage";
// import TermsPage from "features/terms/TermsPage-old";
// import TermsPageNew from "features/terms/TermsPage";
import { useTranslation } from "react-i18next";
import { useQueryString } from "hooks";
import PaymentFailedPage from "features/fail/PaymentFailedPage";
// import BogPayment from "features/bog/BogPayment";
// import PaymentRedirect from "features/paymentRedirect/PaymentRedirect";
import ScrollTop from "components/ScrollTop";
import "./index.css";
import { ChatProvider } from "features/chat";
// import NewLandingPage from "features/newLanding/LandingPage";
import Layout from "features/newLanding/Layout";
import RequestAndSend from "features/newLanding/RequestAndSendSection/RequestAndSend";
import Modal from "features/newLanding/Modal/Modal";
import SuccessModal from "features/newLanding/Modal/SuccessModal";
import LibertyPage from "features/newLanding/components/LibertyPage";
import UsageCases from "features/newLanding/WhyKeepzSection/UsageCases";
// import ForBusiness from "features/newLanding/MerchantsSection/ForBusiness";
import { isMobile } from "react-device-detect";
import Container from "features/newLanding/components/Container";
import PaymentRedirect from "features/paymentRedirect/PaymentRedirect";
import useSWR from "swr";
import axios from "axios";
import { changeLanguage } from "i18next";
import SevricePlans from "features/Pending/ServicePlans";
import { AuthProvider } from "features/context/AuthContext";
import CanonicalHead from "components/CanonicalHead";
import CreateQrPage from "features/create-qr/CreateQRPage";
import AppLayout from "layouts/AuthLayout";
import { IntercomProvider } from "react-use-intercom";
import useSWRMutation from "swr/mutation";
import { saveFMAtoken } from "features/user/api";
import useVisibilityChange from "hooks/useVisibilityChange";
import { setupNotifications } from "config/firebase";
import WarningModal from "features/user/components/WarningModal";
import ContactUsPage from "features/user/ContactUsPage";
import Nuvei from "features/Pending/Nuvei";

// import { Container } from "features/newLanding/components/Container";

// import { isMobile } from "react-device-detect";
// import SupplementaryContractualProvisionsPage from "features/SupplementaryContractualProvisions/SupplementaryContractualProvisionsPage";
// import SkipassTermsPage from "features/terms/SkipassTermsPage";
// import NeolletPending from "features/Pending/NeolletPending";
// import RsGe from "features/Pending/RsGe";
const NewLandingPage = lazy(() => import("features/newLanding/LandingPage"));

// const UsageCases = lazy(() =>
//   import("features/newLanding/WhyKeepzSection/UsageCases")
// );

// const RequestAndSend = lazy(() =>
//   import("features/newLanding/RequestAndSendSection/RequestAndSend")
// );
const ForBusiness = lazy(() =>
  import("features/newLanding/MerchantsSection/ForBusiness")
);
const TermsPageNew = lazy(() => import("features/terms/TermsPage"));
const TermsItMerchant = lazy(() =>
  import("features/terms/TermsItMerchantPage")
);
const TermsItUser = lazy(() => import("features/terms/TermsItUserPage"));

const PrivacyPage = lazy(() => import("features/privacy/PrivacyPage"));
const PrivacyPageIT = lazy(() => import("features/privacy/PrivacyPageIT"));
const QrTerminal = lazy(() =>
  import("features/newLanding/QrTerminal/QrTerminalPage")
);
const SuccessPage = lazy(() => import("features/success"));
const SkiPassPage = lazy(() =>
  import("features/newLanding/SkiPass/SkiPassPage")
);
const BogPaymentWeb = lazy(() => import("features/bog/BogPaymentWeb"));
const BogPayment = lazy(() => import("features/bog/BogPayment"));
const Test = lazy(() => import("features/bog/Test"));
const Test2 = lazy(() => import("features/bog/Test2"));
const Pending = lazy(() => import("features/Pending/Pending"));
const CustomTip = lazy(() => import("features/success/components/CustomTip"));
const SupplementaryContractualProvisionsPage = lazy(() => {
  import(
    "features/SupplementaryContractualProvisions/SupplementaryContractualProvisionsPage"
  );
});
const RedirectPage = lazy(() => import("components/redirect/RedirectPage"));
const StandardPending = lazy(() => import("features/Pending/StandardPending"));
const ThreeDsPending = lazy(() => import("features/Pending/ThreeDsPending"));
const ConsentPending = lazy(() => import("features/Pending/ConsentPending"));
const SkipassTermsPage = lazy(() => import("features/terms/SkipassTermsPage"));
const NeolletPending = lazy(() => import("features/Pending/NeolletPending"));
const RsGe = lazy(() => import("features/Pending/RsGe"));
const ExternalQr = lazy(() => import("features/Pending/ExternalQr"));
const InstallmentPending = lazy(() =>
  import("features/Pending/InstallmentPending")
);
//profile
const LoginPage = lazy(() => import("features/login/LoginPage"));
const OtpPage = lazy(() => import("features/OTP/OtpPage"));
const RegisterPage = lazy(() => import("features/register/RegisterPage"));
const UserQRpage = lazy(() => import("features/user/UserQRpage"));
const TransactionsPage = lazy(() => import("features/user/TransactionsPage"));
const SingleTransactionPage = lazy(() =>
  import("features/user/SingleTransactionPage")
);
const LimitsPage = lazy(() => import("features/user/LimitsPage"));
const IdentomtFinalize = lazy(() => import("features/user/IdentomtFinalize"));
const ProfilePage = lazy(() => import("features/user/ProfilePage"));
const ProfileEditPage = lazy(() => import("features/user/ProfileEditPage"));
const MobileEditPage = lazy(() => import("features/user/MobileEditPage"));
const IbansPage = lazy(() => import("features/user/IbansPage"));
const CreateIbanPage = lazy(() => import("features/user/CreateIbanPage"));
const EditIbanPage = lazy(() => import("features/user/EditIbanPage"));
const CardsPage = lazy(() => import("features/user/CardsPage"));
const SettingsPage = lazy(() => import("features/user/SettingsPage"));
const SecurityPage = lazy(() => import("features/user/SecurityPage"));

const BulkSms = lazy(() => import("features/bulk-sms/BulkSms"));

const App = () => {
  const isForeground = useVisibilityChange();
  const FCMtoken = localStorage.getItem("FCMtoken");
  const [warning, setWarning] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { parseQuery: parsedQuery } = useQueryString();
  const { tiny } = parsedQuery;

  // const { data: { country_code = "" } = {} } = useSWR(
  //   "https://ipapi.co/json/?key=IWQMQ2tVItnM8sbz9L2BsWaSkgktWlglQKoPbsi0F811MGfx6o",
  //   async (url) => {
  //     const response = await axios.get(url);
  //     return response.data;
  //   }
  // );

  if (tiny) {
    window.location.href = `https://tinyurl.com/${tiny}`;
  }
  const { i18n } = useTranslation();

  function getParams(url) {
    // Fix the issue: Replace the first occurrence of '?' with '&' if there are multiple '?'
    let firstQuestionMarkIndex = url.indexOf("?");
    let remainingPart = url.slice(firstQuestionMarkIndex + 1); // Everything after the first '?'

    if (remainingPart.includes("?")) {
      url = url.replace(/\?(?=[^?]*$)/, "&"); // Replace only the second '?'
    }

    // Parse the corrected URL
    const urlObj = new URL(url, window.location.origin); // Base URL needed for parsing
    const params = new URLSearchParams(urlObj.search);

    return {
      lng: params.get("lng") || null,
    };
  }

  const { lng } = getParams(window.location.href);

  useEffect(() => {
    if (!lng) return;
    let newLng = "en";
    if (lng === "ka") {
      newLng = "ka";
      i18n.changeLanguage(newLng);
      return;
    } else if (lng === "it") {
      newLng = "it";
      i18n.changeLanguage(newLng);
      return;
    }
    i18n.changeLanguage(newLng);
  }, [lng]);

  useEffect(() => {
    console.log(navigator);
    if ("permissions" in navigator) {
      navigator.permissions
        .query({ name: "notifications" })
        .then((permissionStatus) => {
          console.log("Initial state:", permissionStatus.state);

          permissionStatus.onchange = () => {
            console.log("Permission changed to:", permissionStatus.state);
            // You can re-call setupNotifications or handle changes here
          };
        });
    }
  }, []);

  // useEffect(() => {
  //   // console.log("firebase useeffect");

  //   setupNotifications((message) => {
  //     // console.log("MESSAGE", message);

  //     if (isForeground) {
  //       // App is in the foreground, show toast notification
  //       // toastNotification({
  //       //   title : '',
  //       //   description: body,
  //       //   status: "info",
  //       // });
  //       // console.log("foreground");
  //     } else {
  //       // console.log("background");
  //       // App is in the background, show native notification
  //       // sendNativeNotification({
  //       //   title,
  //       //   body,
  //       // });
  //     }
  //   }, setWarning);
  // }, [isForeground, FCMtoken]);

  // useEffect(() => {
  //   let newLng = "en";
  //   if (!lng) return;
  //   if (lng === "ka" && country_code === "GE") {
  //     newLng = "ka";
  //     i18n.changeLanguage(newLng);
  //     return;
  //   } else if (lng === "it" && country_code === "IT") {
  //     newLng = "it";
  //     i18n.changeLanguage(newLng);
  //     return;
  //   }
  //   i18n.changeLanguage(newLng);
  // }, [lng, country_code]);

  function openContactModel() {
    setShowContactModal(true);
  }

  const reload = () => {
    window.location.reload();
  };

  //h-full max-w-[480px]  md:max-w-[1280px] lg:max-w-[1920px] mx-auto
  return (
    <div className="h-full">
      <CanonicalHead />
      {showContactModal === true && (
        <Modal
          setShowContactModal={setShowContactModal}
          setSuccessModal={setSuccessModal}
        />
      )}
      {showContactModal === false && successModal === true ? (
        <SuccessModal setSuccessModal={setSuccessModal} />
      ) : null}
      <Routes>
        <Route
          path="/"
          element={
            <ChatProvider>
              <Layout isWhite={false} openContactModel={openContactModel}>
                <React.Suspense>
                  <NewLandingPage openContactModel={openContactModel} />
                </React.Suspense>
              </Layout>
            </ChatProvider>
          }
        ></Route>
        <Route
          path="/how-to-use-QR-terminal"
          element={
            <ChatProvider>
              <Layout isWhite={true}>
                <Container>
                  {/* <React.Suspense> */}
                  <RequestAndSend openContactModel={openContactModel} />
                  {/* </React.Suspense> */}
                </Container>
              </Layout>
            </ChatProvider>
          }
        />
        <Route
          path="/use-cases"
          element={
            <ChatProvider>
              <Layout isWhite={true} openContactModel={openContactModel}>
                <Container>
                  <UsageCases />
                </Container>
              </Layout>
            </ChatProvider>
          }
        />
        <Route
          path="/for-business"
          element={
            <ChatProvider>
              <Layout isWhite={true} openContactModel={openContactModel}>
                <Container>
                  <React.Suspense>
                    <ForBusiness openContactModel={openContactModel} />
                  </React.Suspense>
                </Container>
              </Layout>
            </ChatProvider>
          }
        />
        <Route
          path="/qr-terminal"
          element={
            <ChatProvider>
              <Layout isWhite={true} openContactModel={openContactModel}>
                <React.Suspense>
                  <QrTerminal openContactModal={openContactModel} />
                </React.Suspense>
              </Layout>
            </ChatProvider>
          }
        />
        <Route
          path="/skipass"
          element={
            <ChatProvider>
              <Layout isWhite={true} openContactModel={openContactModel}>
                <Container>
                  <React.Suspense>
                    <SkiPassPage />
                  </React.Suspense>
                </Container>
              </Layout>
            </ChatProvider>
          }
        />
        {/* <Route path="/tippage" element={<EmoneyTipPage />} /> */}
        {/* <Route path="/tipping" element={<PaymentRedirect />} /> */}
        <Route
          path="/pay"
          element={
            <React.Suspense>
              {isMobile ? <BogPayment /> : <BogPaymentWeb />}
            </React.Suspense>
          }
        />
        <Route
          path="/test"
          element={
            <React.Suspense>
              <Test />
            </React.Suspense>
          }
        />
        <Route
          path="/bulk-sms"
          element={
            <React.Suspense>
              <BulkSms />
            </React.Suspense>
          }
        />
        <Route
          path="/test2"
          element={
            <React.Suspense>
              <Test2 />
            </React.Suspense>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <React.Suspense>
              <TermsPageNew />
            </React.Suspense>
          }
        />
        <Route
          path="/terms-and-conditions-it"
          element={
            <React.Suspense>
              <TermsItMerchant />
            </React.Suspense>
          }
        />{" "}
        <Route
          path="/terms-and-conditions-it-user"
          element={
            <React.Suspense>
              <TermsItUser />
            </React.Suspense>
          }
        />
        <Route
          path="/skipass-terms"
          element={
            <React.Suspense>
              <SkipassTermsPage />
            </React.Suspense>
          }
        />
        <Route
          path="/privacy"
          element={
            <React.Suspense>
              <PrivacyPage />
            </React.Suspense>
          }
        />
        <Route
          path="/privacy-it"
          element={
            <React.Suspense>
              <PrivacyPageIT />
            </React.Suspense>
          }
        />
        <Route
          path="/contractual-provisions"
          element={
            <React.Suspense>
              <SupplementaryContractualProvisionsPage />
            </React.Suspense>
          }
        />
        <Route
          path="/success"
          element={
            <React.Suspense>
              <SuccessPage />
            </React.Suspense>
          }
        />
        <Route
          path="/pending"
          element={
            <React.Suspense>
              <Pending />
            </React.Suspense>
          }
        />
        <Route
          path="/ex"
          element={
            <React.Suspense>
              <ExternalQr />
            </React.Suspense>
          }
        />
        <Route
          path="/consent"
          element={
            <React.Suspense>
              <ConsentPending />
            </React.Suspense>
          }
        />
        <Route
          path="/standard-pending"
          element={
            <React.Suspense>
              <StandardPending />
            </React.Suspense>
          }
        />
        <Route
          path="/3ds-pending"
          element={
            <React.Suspense>
              <ThreeDsPending />
            </React.Suspense>
          }
        />
        <Route
          path="/nPending"
          element={
            <React.Suspense>
              <NeolletPending />
            </React.Suspense>
          }
        />
        <Route
          path="/installment-pending"
          element={
            <React.Suspense>
              <InstallmentPending />
            </React.Suspense>
          }
        />
        <Route
          path="/rs"
          element={
            <React.Suspense>
              <RsGe />
            </React.Suspense>
          }
        />
        <Route path="/payment-failed" element={<PaymentFailedPage />} />
        <Route path="/downtime" element={<DowntimePage />} />
        <Route path="/apple-app-site-association" onEnter={reload} />
        <Route path="/tipping" element={<PaymentRedirect />} />
        <Route path="/service-plans" element={<SevricePlans />} />
        <Route path="/nuvei-kyb" element={<Nuvei />} />
        <Route
          path="/login"
          element={
            <AuthProvider>
              <React.Suspense>
                <LoginPage />
              </React.Suspense>
            </AuthProvider>
          }
        />
        <Route
          path="/otp"
          element={
            <AuthProvider>
              <React.Suspense>
                <OtpPage />
              </React.Suspense>
            </AuthProvider>
          }
        />
        <Route
          path="/register"
          element={
            <AuthProvider>
              <React.Suspense>
                <RegisterPage />
              </React.Suspense>
            </AuthProvider>
          }
        />
        {/* <Route path="/create-qr" element={<CreateQrPage />} /> */}
        {/* APP LAYOUT */}
        <Route
          element={
            <AuthProvider>
              <ChatProvider>
                <AppLayout />
              </ChatProvider>
            </AuthProvider>
          }
        >
          <Route
            path="/user-acc"
            element={
              <React.Suspense>
                <UserQRpage />
              </React.Suspense>
            }
          />
          <Route
            path="/transactions"
            element={
              <React.Suspense>
                <TransactionsPage />
              </React.Suspense>
            }
          />
          <Route
            path="/transactions/:id"
            element={
              <React.Suspense>
                <SingleTransactionPage />
              </React.Suspense>
            }
          />
          <Route
            path="/limits"
            element={
              <React.Suspense>
                <LimitsPage />
              </React.Suspense>
            }
          />
          <Route
            path="/identomat-finalize"
            element={
              <React.Suspense>
                <IdentomtFinalize />
              </React.Suspense>
            }
          />
          <Route
            path="/profile"
            element={
              <React.Suspense>
                <ProfilePage />
              </React.Suspense>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <React.Suspense>
                <ProfileEditPage />
              </React.Suspense>
            }
          />
          <Route
            path="/mobile-edit"
            element={
              <React.Suspense>
                <MobileEditPage />
              </React.Suspense>
            }
          />
          <Route
            path="/cards"
            element={
              <React.Suspense>
                <CardsPage />
              </React.Suspense>
            }
          />
          <Route
            path="/settings"
            element={
              <React.Suspense>
                <SettingsPage />
              </React.Suspense>
            }
          />
          <Route
            path="/settings/security"
            element={
              <React.Suspense>
                <SecurityPage />
              </React.Suspense>
            }
          />
          <Route
            path="/contact"
            element={
              <React.Suspense>
                <ContactUsPage />
              </React.Suspense>
            }
          />
          ,
          <Route
            path="/ibans"
            element={
              <React.Suspense>
                <IbansPage />
              </React.Suspense>
            }
          />
          <Route
            path="/iban-create"
            element={
              <React.Suspense>
                <CreateIbanPage />
              </React.Suspense>
            }
          />
          ,
          <Route
            path="/iban-edit"
            element={
              <React.Suspense>
                <EditIbanPage />
              </React.Suspense>
            }
          />
          ,
        </Route>
        <Route
          path="/custom-tip"
          element={
            <React.Suspense>
              <CustomTip />
            </React.Suspense>
          }
        />
        <Route
          path="/redirect"
          element={
            <React.Suspense>
              <RedirectPage />
            </React.Suspense>
          }
        />
        <Route
          path="/lb"
          element={
            <React.Suspense>
              <LibertyPage />
            </React.Suspense>
          }
        />
      </Routes>
      <ScrollTop />
      <WarningModal
        open={warning}
        width="300px"
        onClick={() => setWarning(false)}
        closeOnOuterClick={true}
        heading={"You have blocked notifications"}
        warningText={"Please enable them manually in your browser settings."}
      />
    </div>
  );
};

export default App;
